import BaseComponent from 'foundation/base-component';
import React from 'react';
import { render } from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';
import configureStore from './store/configure-store';
import CustomAnalyticsAppComponent from './views/CustomAnalyticsAppComponent';

export default class CustomAnalyticsComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        this.data = {};

        try {
            this.data = JSON.parse(this.getAttribute(this.refs.data, 'options'));
        } catch (error) {
            console.log(error.message);
        }

        if (!this.data) {
            console.log('No data found');
            return;
        }

        const store = configureStore();
        render(
            <ReduxProvider store={store}>
                <CustomAnalyticsAppComponent
                    analyticsPageProperties={this.data}
                ></CustomAnalyticsAppComponent>
            </ReduxProvider>,
            this.refs.section
        );
    }
}
